/**
 * Lead formatting helpers.
 *
 * Shared presentational maps for lead attributes so the pipeline board and
 * the listing-detail interested-buyers surface can't drift on colour.
 */

import type { LeadTemperature } from "@/features/realtor/services/leads-api.service";

/**
 * Temperature → dot colour class. The single source for the coloured
 * temperature dot rendered by both `TempDot` (interested-buyers section)
 * and `TempBadge` (pipeline card). Keep the two components' distinct
 * render shapes (bare dot vs ringed badge); only the colour map is shared.
 */
export const TEMPERATURE_DOT_CLASS: Record<LeadTemperature, string> = {
	hot: "bg-dashboard-pill-risk",
	warm: "bg-dashboard-pill-awaiting",
	cold: "bg-dashboard-pill-info",
};
